import { SITE } from "@/config/site";

interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  image?: string;
  imageAlt?: string;
  type?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const DEFAULT_IMAGE =
  "https://readdy.ai/api/search-image?query=Cinematic%20dark%20broadcast%20control%20wall%20with%20glowing%20live%20video%20monitors%20and%20warm%20amber%20light%2C%20deep%20charcoal%20tone%2C%20moody%20editorial%20photography%2C%20high%20detail&width=1200&height=630&seq=blzb-og-01&orientation=landscape";

export default function Seo({
  title,
  description,
  keywords,
  path,
  image = DEFAULT_IMAGE,
  imageAlt = "爆料直播现场实时画面信号墙",
  type = "website",
  jsonLd,
}: SeoProps) {
  const canonical = `${SITE.url}${path}`;
  const payload = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {payload.map((block, index) => (
        <script
          key={`jsonld-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
        />
      ))}
    </>
  );
}